export * as places from '@wix/auto_sdk_atlas_places/meta';
export * as autocomplete from '@wix/auto_sdk_atlas_autocomplete/meta';
export * as location from '@wix/auto_sdk_atlas_location/meta';
